import React, { useState, useCallback, useContext } from "react";
import Cookies from "js-cookie";

import useAxios from "../../hooks/useAxiosChat";

import CustomButton from "../button/CustomButton";
import { CustomInput } from "../Inputs/Inputs";
// import AuthenticationContext from "../../Authentication/AuthenticationContext";
import { useNavigate } from "react-router-dom";

interface VerifyCodChatProps {
  mobile: string;
  hashCode: string;
  setStep: (state: number) => void;
  get_mag: () => void;

  checkCookie: () => void;
}

const VerifyCodeChat: React.FC<VerifyCodChatProps> = ({
  mobile,
  hashCode,
  setStep,
  get_mag,

  checkCookie,
}) => {
  const nav = useNavigate();

  // const { login } = useContext(AuthenticationContext);

  const { execute, loading } = useAxios("api/login");

  const [code, setCode] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");

  const codeInputChangeHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >(
    (event) => {
      setCode(event.target.value);
    },
    [setCode]
  );

  const back = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      setStep(1);
    },
    [setStep]
  );

  const submit = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      if (loading) return;
      if (code.length !== 6) {
        setErrorMessage("لطفا کد ورود را به درستی وارد نمایید.");
        return;
      } else if (errorMessage !== "") {
        setErrorMessage("");
      }
      execute({
        mobile,
        hashcode: hashCode,
        code,
      }).then((res) => {
        if (+res.status === 1) {
          Cookies.set("token", res["data"]["usertoken"], {
            expires: 7,
          });
          checkCookie();
          if (res["userinfo"]["fullname"] == "") {
            setStep(3);
          } else {
            setStep(4);
            get_mag();
          }
        }
      });
    },
    [mobile, execute, loading, hashCode, code]
  );

  return (
    <form>
      <CustomInput
        type="text"
        label="لطفا کد ارسال شده به شماره تلفن همراه خود را وارد نمایید."
        labelClassName="login-input-label mb-3"
        inputContainer="mb-4 mx-2"
        inputValue={code}
        placeholder="XXXXXX"
        textErr={errorMessage}
        // @ts-ignore
        onChangeFunc={codeInputChangeHandler}
      />
      <div className="login-button-box d-flex justify-content-between">
        <CustomButton
          className="btn btn-danger px-3 py-2 w-25 justify-content-center"
          color="warning"
          onClick={back}
        >
          قبلی
        </CustomButton>
        <CustomButton
          className="btn btn-primary px-3 py-2 w-25 justify-content-center"
          color="primary"
          btnType="submit"
          onClick={submit}
        >
          ورود
        </CustomButton>
      </div>
    </form>
  );
};

export default VerifyCodeChat;
